import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-white dark:bg-[#0c1427] p-5 rounded-md shadow-md flex flex-col min-h-[450px] items-center justify-center"
}
const _hoisted_2 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_3 = {
  key: 2,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_4 = { class: "bg-white dark:bg-[#0c1427] p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-md mx-4 z-10 relative" }
const _hoisted_5 = { class: "flex justify-between items-center mb-4" }
const _hoisted_6 = { class: "text-lg font-medium text-black dark:text-white" }
const _hoisted_7 = { class: "mb-6" }
const _hoisted_8 = { class: "text-gray-700 dark:text-gray-300" }
const _hoisted_9 = { class: "text-gray-500 text-sm mt-2" }
const _hoisted_10 = { class: "flex justify-between pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomFieldsPanel = _resolveComponent("CustomFieldsPanel")!
  const _component_CustomFieldEditor = _resolveComponent("CustomFieldEditor")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.organizationId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary-500 mb-4" }, null, -1)),
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.directT('common.loadingOrganizationSettings')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.organizationId)
      ? (_openBlock(), _createBlock(_component_CustomFieldsPanel, {
          key: 1,
          organizationId: _ctx.organizationId,
          onFieldSaved: _ctx.handleFieldEdit,
          onFieldDeleted: _ctx.handleFieldDelete
        }, null, 8, ["organizationId", "onFieldSaved", "onFieldDeleted"]))
      : _createCommentVNode("", true),
    _createVNode(_component_CustomFieldEditor, {
      visible: _ctx.showFieldEditor,
      field: _ctx.editingField,
      editMode: _ctx.isEditMode,
      existingKeys: [],
      onClose: _ctx.closeEditor,
      onSave: _ctx.saveField
    }, null, 8, ["visible", "field", "editMode", "onClose", "onSave"]),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black opacity-50",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args)))
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.directT('settings.leadsSettings.customFields.confirmDeletion')), 1),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                class: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-2 -m-2"
              }, _cache[5] || (_cache[5] = [
                _createElementVNode("i", { class: "material-symbols-outlined text-xl" }, "close", -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.directT('confirmDeletionMessage', { fieldName: _ctx.fieldToDelete?.label })), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.directT('confirmDeletionWarning')), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                class: "inline-block py-2 px-4 bg-gray-100 text-gray-800 transition-all hover:bg-gray-200 rounded-md border border-gray-100 hover:border-gray-200 dark:bg-[#172036] dark:text-gray-200 dark:hover:bg-[#1e2746] dark:border-[#172036] dark:hover:border-[#1e2746]"
              }, _toDisplayString(_ctx.directT('settings.leadsSettings.delete.cancel')), 1),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
                class: "inline-block py-2 px-4 bg-danger-500 text-white transition-all hover:bg-danger-400 rounded-md border border-danger-500 hover:border-danger-400"
              }, _toDisplayString(_ctx.directT('settings.leadsSettings.delete.confirm')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}